// @ts-nocheck
import { store } from "~/state/store";
import { CONFIG } from "~/config";
import { EMAIL_REGEXP } from "~/report/const";
import { _ } from "~/i18n";
import { analyticsLog } from "~/util/analyticsAction";
import { node, icon, text } from "~/util/dom";

export default class MyMapsShareLinks {
	/**
	 *
	 * @param {MyMapsShare} owner Nadřazenýá instance
	 * @param {Object} data Data
	 */
	constructor(owner, data, twitterText) {
		this._owner = owner;
		this._twitterText = twitterText || document.title;

		this._shortLink = null;
		this._link = null;
		this._qr = null;

		this._emailProvider = new MyMapsEmailProvider();

		this._dom = {
			container: node("div", { className: "share-tab active" }),
			inputShare: node("input", { type: "checkbox" }),
			slider: node("span", { className: "share-slider" }),
			textContainer: node("div", { className: "share-text-container" }),
			buttonContainer: node("div", { className: "share-buttons" }),
			buttonMail: node("button", { className: "share-mail", type: "button" }),
			buttonQr: node("button", { className: "share-qr", type: "button" }),
			buttonFb: node("a", { className: "share-fb", target: "_blank" }),
			buttonTw: node("a", { className: "share-tw", target: "_blank" }),
			inputsContainer: node("div", { className: "inputs" }),
			buttonCopy: node("button", { className: "copy", type: "button" }, _("action.share.copy")),
			shortAddress: node("input", { type: "text" }),
			mailTo: node("input", { type: "text", placeholder: _("mymap.share.placeholder.to") }),
			mailMessage: node("textarea", { placeholder: _("mymap.share.placeholder.message") }),
			buttonMailSubmit: node("button", { className: "share-mail-send", type: "button" }, _("mymap.share.submit")),
			buttonMailCancel: node("button", { className: "share-mail-cancel", type: "button" }, _("cancel")),
			emailToError: node("div", { className: "recipient-error" }),
			emailSubmitError: node("div", { className: "submit-error" }),
			buttonQrCancel: node("button", { className: "qr-cancel", type: "button" }, _("cancel")),
			saveQrPng: node("button", { className: "qr-download", type: "button", disabled: "disabled" }, `${_("download")} PNG`),
			saveQrSvg: node("button", { className: "qr-download", type: "button", disabled: "disabled" }, `${_("download")} SVG`),
			qrImage: node("img", { width: "238", height: "238", className: "qr-image" }),
			error: node("p", { className: "error" }),
			loader: node("img", { src: "/img/loader.gif", className: "qr-spinner" }),
		};

		this._data = data;

		this._build();

		this._switchMail(false);
	}

	/**
	 * Vrátí kontejner
	 */
	get container() {
		return this._dom.container;
	}

	/**
	 * Vloží chybovou hlášku
	 */
	set error(msg) {
		this._dom.error.textContent = msg || "";
	}

	/**
	 * Nastaví titulek typu
	 */
	set titleType(titleType) {
		const name = this._data.usertitle && this._data.usertitle !== "" ? this._data.usertitle : this._data.title;

		this._owner.sharedDom.labelShareSpan.textContent = _("mymap.share.shareWith", { name, type: _(`mymap.share.${titleType}`) });
	}

	/**
	 * Nastaví adresu do potřebných políček a odkazů, pokud adresa není, smaže je.
	 * @param {String} [link=""] URL
	 */
	set shortLink(link) {
		if (!this._owner.isActive) {
			return;
		}
		this._shortLink = link;

		this._dom.shortAddress.value = this._shortLink;
		const encodedLink = encodeURIComponent(this._shortLink);

		this._dom.buttonFb.href = this._shortLink ? `https://www.facebook.com/sharer.php?u=${encodedLink}` : "";
		this._dom.buttonTw.href = this._shortLink
			? `https://twitter.com/share?&url=${encodedLink}${this._twitterText
				? `&text=${encodeURIComponent(this._twitterText)}`
				: ""}`
			: "";

		this._select();
	}

	set link(link) {
		this._link = link;
	}

	/**
	 * Zachycení události
	 * @param {Event} e
	 */
	handleEvent(event) {
		const trg = event.target;

		if (event.type === "click") {
			if (this._owner.isActive) {
				if (trg === this._dom.buttonCopy) {
					event.preventDefault();
					this._select();
					document.execCommand("copy");

					analyticsLog(this._data, {
						text: this._dom.buttonCopy.innerText,
					});
				} else if (trg === this._dom.buttonMail || this._dom.buttonMail.contains(trg)) {
					event.preventDefault();
					this._switchMail(true);

					analyticsLog(this._data, {
						text: this._dom.buttonMail.innerText,
					});
				} else if (trg === this._dom.buttonMailCancel) {
					event.preventDefault();
					this._clearError();
					this._switchMail(false);
					analyticsLog(this._data, {
						text: this._dom.buttonMailCancel.innerText,
					});
				} else if (trg === this._dom.buttonMailSubmit) {
					event.preventDefault();
					this._sendMail();
					analyticsLog(this._data, {
						text: this._dom.buttonMailSubmit.innerText,
					});
				} else if (trg === this._dom.buttonQr || this._dom.buttonQr.contains(trg)) {
					this._switchQr(true);
					analyticsLog(this._data, {
						text: this._dom.buttonQr.innerText,
					});
				} else if (trg === this._dom.buttonQrCancel) {
					this._switchQr();
					analyticsLog(this._data, {
						text: this._dom.buttonQrCancel.innerText,
					});
				} else if (trg === this._dom.saveQrPng) {
					this._downloadQr("png");
					analyticsLog(this._data, {
						text: this._dom.saveQrPng.innerText,
					});
				} else if (trg === this._dom.saveQrSvg) {
					this._downloadQr("svg");
					analyticsLog(this._data, {
						text: this._dom.saveQrSvg.innerText,
					});
				} else if (trg === this._dom.buttonFb || trg === this._dom.buttonTw) {
					const btn = trg === this._dom.buttonFb ? this._dom.buttonFb : this._dom.buttonTw;

					analyticsLog(this._data, {
						text: btn.innerText,
						url: btn.href,
					});

					this._owner.shared = true;
				}
			} else {
				event.preventDefault();
			}
		}
	}

	/**
	 * Nastavení aktivního prvku
	 */
	setActive() {
		if (!this._owner.isActive) {
			this._dom.shortAddress.value = "";
			this._switchMail(false);
		}
	}

	/**
	 * Zobrazí nebo skryje prvky
	 * @param {Boolean} show
	 */
	showHide(show) {
		if (show) {
			if (this._data.text) {
				this._dom.container.appendChild(this._dom.textContainer);
			}
			this._dom.container.appendChild(this._dom.buttonContainer);
			this._dom.container.appendChild(this._dom.inputsContainer);
			this._dom.container.appendChild(this._dom.error);
		} else {
			this._dom.textContainer.remove();
			this._dom.buttonContainer.remove();
			this._dom.inputsContainer.remove();
			this._dom.error.remove();
		}
	}

	/**
	 * Vytvoří DOM
	 */
	_build() {
		const { user } = store.getState().user;

		if (["places-root", "activities-root"].indexOf(this._data.type) > -1) {
			this._dom.container.appendChild(this._owner.sharedDom.warning);
			this._dom.container.appendChild(this._owner.sharedDom.warningSw);
		}

		this._dom.buttonCopy.addEventListener("click", this, false);
		this._dom.buttonMail.addEventListener("click", this, false);
		this._dom.buttonMailSubmit.addEventListener("click", this, false);
		this._dom.buttonMailCancel.addEventListener("click", this, false);
		this._dom.buttonQr.addEventListener("click", this, false);
		this._dom.buttonQrCancel.addEventListener("click", this, false);
		this._dom.saveQrPng.addEventListener("click", this, false);
		this._dom.saveQrSvg.addEventListener("click", this, false);
		this._dom.buttonFb.addEventListener("click", this, false);
		this._dom.buttonTw.addEventListener("click", this, false);

		this._dom.buttonCopy.setAttribute("data-log-ignore", "1");
		this._dom.buttonMail.setAttribute("data-log-ignore", "1");
		this._dom.buttonMailSubmit.setAttribute("data-log-ignore", "1");
		this._dom.buttonMailCancel.setAttribute("data-log-ignore", "1");
		this._dom.buttonQr.setAttribute("data-log-ignore", "1");
		this._dom.buttonQrCancel.setAttribute("data-log-ignore", "1");
		this._dom.saveQrPng.setAttribute("data-log-ignore", "1");
		this._dom.saveQrSvg.setAttribute("data-log-ignore", "1");
		this._dom.buttonFb.setAttribute("data-log-ignore", "1");
		this._dom.buttonTw.setAttribute("data-log-ignore", "1");

		this._dom.buttonFb.appendChild(icon("facebook"));
		this._dom.buttonFb.appendChild(text("Facebook"));
		this._dom.buttonFb.title = "Facebook";
		this._dom.buttonContainer.appendChild(this._dom.buttonFb);

		this._dom.buttonTw.appendChild(icon("x"));
		this._dom.buttonTw.appendChild(text("X"));
		this._dom.buttonTw.title = "X";
		this._dom.buttonContainer.appendChild(this._dom.buttonTw);

		if (user.state === "green" && (user.accountDisplayName || "").match(EMAIL_REGEXP)) {
			this._dom.buttonMail.appendChild(icon("email"));
			this._dom.buttonMail.appendChild(text("E-mail"));
			this._dom.buttonMail.title = "E-mail";
			this._dom.buttonContainer.appendChild(this._dom.buttonMail);
		}

		this._dom.buttonQr.appendChild(icon("qr"));
		this._dom.buttonQr.appendChild(text("QR"));
		this._dom.buttonQr.title = "QR";
		this._dom.buttonContainer.appendChild(this._dom.buttonQr);

		this._dom.shortAddress.setAttribute("readonly", "");

		if (this._data.text) {
			this._dom.textContainer.appendChild(this._data.text);
		}

		if (["places-root", "activities-root"].indexOf(this._data.type) === -1) {
			if (this._data.like) {
				this._dom.container.appendChild(this._owner.sharedDom.swDiv);
			}
			if (this._data.text) {
				this._dom.container.appendChild(this._dom.textContainer);
			}
			this._dom.container.appendChild(this._dom.buttonContainer);
			this._dom.container.appendChild(this._dom.inputsContainer);
			this._dom.container.appendChild(this._dom.error);
		}
	}

	/**
	 * Přepne políčko s mailem
	 * @param {Boolean} toMail Přepnout do mailové podoby
	 */
	_switchMail(toMail) {
		Mapy.Util.clear(this._dom.inputsContainer);

		this._dom.buttonQr.classList.remove("active");

		if (toMail) {
			this._dom.buttonMail.classList.add("active");
			this._dom.inputsContainer.appendChild(this._dom.mailTo);
			this._dom.inputsContainer.appendChild(this._dom.emailToError);
			this._dom.inputsContainer.appendChild(this._dom.mailMessage);
			this._dom.inputsContainer.appendChild(this._dom.buttonMailSubmit);
			this._dom.inputsContainer.appendChild(this._dom.buttonMailCancel);
			this._dom.inputsContainer.appendChild(this._dom.emailSubmitError);
			this._dom.mailTo.focus();
		} else {
			this._dom.buttonMail.classList.remove("active");
			this._dom.inputsContainer.appendChild(this._dom.shortAddress);
			this._dom.inputsContainer.appendChild(this._dom.buttonCopy);
			this._select();
		}
	}

	_switchQr(open) {
		Mapy.Util.clear(this._dom.inputsContainer);

		this._dom.buttonMail.classList.remove("active");

		if (open) {
			this._dom.buttonQr.classList.add("active");

			this._dom.inputsContainer.appendChild(this._qr ? this._dom.qrImage : this._dom.loader);
			this._dom.inputsContainer.appendChild(this._dom.saveQrPng);
			this._dom.inputsContainer.appendChild(this._dom.saveQrSvg);
			this._dom.inputsContainer.appendChild(this._dom.buttonQrCancel);

			if (!this._qr) {
				this._getShortUrl();
			}
		} else {
			this._dom.buttonQr.classList.remove("active");
			this._dom.inputsContainer.appendChild(this._dom.shortAddress);
			this._dom.inputsContainer.appendChild(this._dom.buttonCopy);
			this._select();
		}
	}

	/**
	 * Vybere text v políčku s adresou
	 */
	_select() {
		if (this._owner.isActive) {
			this._dom.shortAddress.focus();
			this._dom.shortAddress.select();
		}
	}

	/**
	 * Zařídí odeslání emailu
	 */
	_sendMail() {
		this._clearError();
		const data = this._getData();

		if (data.error) {
			if (!data.error.to) {
				this._dom.mailTo.classList.add("error");
				this._dom.emailToError.textContent = _("sendByMail.badEmail");
			}
			if (!data.error.from) {
				this._dom.emailSubmitError.textContent = _("mymap.share.loginError");
			}

			return;
		}
		this._emailProvider.send(data).then(info => {
			if (info.error) {
				this._dom.emailSubmitError.textContent = info.error;
			} else {
				this._shared = true;
				this._owner.close();
				const origin = (("fromDC" in this._data && this._data.fromDC && !this._data.like) || !this._data.like) && !this._data.myGallery ? "web" : "my_maps";
				const type = "fromDC" in this._data && this._data.fromDC && !this._data.like ? "map" : this._data.type;
				const logData = {
					type,
					origin,
				};
				const galleryData = Mapy.getComponent("gallery").isActive() ? Mapy.getComponent("gallery").logData : Mapy.getComponent("photoDetail").options?.galleryType ? { galleryType: Mapy.getComponent("photoDetail").options.galleryType } : {};
				const photoData = Mapy.getComponent("photoDetail").isActive()
					? {
						galleryType: galleryData.galleryType ? galleryData.galleryType : "photomap",
						place: "detail",
					}
					: {};

				Object.assign(logData, galleryData, photoData);

				Mapy.getComponent("logger").log("email-leti", {
					...logData,
					...this._data.analytics ? this._data.analytics : {},
				});
			}
		}, () => {});
	}

	/**
	 * Odstraní z okna hlášky s chybou
	 */
	_clearError() {
		this._dom.mailTo.classList.remove("error");
		this._dom.emailToError.textContent = "";
		this._dom.emailSubmitError.textContent = "";
	}

	/**
	 * Sesbírá data z formuláře pro odeslání emailu
	 * @return {Object}
	 */
	_getData() {
		const { user } = store.getState().user;
		const to = this._dom.mailTo.value.trim();
		// FIXME jak zachazet s poslanim emailu, kdyz nemam email?
		const from = user.accountDisplayName;

		const checked = this._emailProvider.checkAddress(from, to);

		if (!checked.from || !checked.to) {
			return { error: checked };
		}

		const data = {};

		data.to = to;
		data.from = from;
		data.message = this._dom.mailMessage.value;
		data.link = this._shortLink || this._link || window.location.href.replace("&box=1", "");

		return data;
	}

	_getShortUrl() {
		const url = `${this._data.url && this._data.url !== "" ? this._data.url : window.location.href}&utm_source=mapy&utm_medium=qrcode`;

		Mapy.Util.getShortLink(url).then(data => {
			this._qr = {
				url: data.url,
			};
			this._getQr(data.url);
		}, () => {});
	}

	_getQr(url) {
		this._dom.saveQrSvg.disabled = false;
		this._dom.saveQrPng.disabled = false;

		Mapy.Util.request(`${CONFIG.requestUrl}/qrgen/qr?size=238`, {
			method: "post",
			type: "blob",
			json: { url },
			headers: {
				// eslint-disable-next-line quote-props
				"Accept": "image/png",
			},
		}).promise.then(data => {
			if (data.status === 200) {
				this._dom.qrImage.src = URL.createObjectURL(data.data);
				this._dom.loader.replaceWith(this._dom.qrImage);
			}
		}, () => {});
	}

	_downloadQr(type) {
		if (this._qr) {
			Mapy.Util.request(`${CONFIG.requestUrl}/qrgen/qr?size=500&download=true`, {
				method: "post",
				type: "blob",
				json: { url: this._qr.url },
				headers: {
					// eslint-disable-next-line quote-props
					"Accept": `image/${type === "svg" ? `svg` : `png`}`,
				},
			}).promise.then(data => {
				if (data.status === 200) {
					Mapy.Util.startBlobDownload(data.data, `mapycom-qr.${type === "svg" ? `svg` : `png`}`);
				}
			}, () => {});
		}
	}
}
